import { CredentialVaultListView } from './credentialVaultList';

export default function PersonalVaultList() {
  return <CredentialVaultListView scope="personal" />;
}
